import useQuery, { useRevalidate } from "./useQuery";
import useDebouncedCallback from "@ui/lib/hooks/useDebouncedCallback";
import { useChannel } from "./ws/useChannel";

const PATH = "/projects/:projectId(uuid)/quantities/displayFilters";

export const useDisplayFilters = (projectId: string) => {
  const revalidate = useRevalidate();
  const callback = useDebouncedCallback(
    () => {
      void revalidate(PATH, { projectId });
    },
    [revalidate, projectId],
    2_000,
    {
      leading: true,
      maxWait: 2_000,
      trailing: true,
    },
  );
  useChannel({ key: "quantities", projectId }, callback, true);

  const displayFilters = useQuery(PATH, { routeParams: { projectId } });
  const displayFilterscallback = useDebouncedCallback(
    () => {
      void revalidate(PATH, { projectId });
    },
    [revalidate, projectId],
    2_000,
    {
      leading: true,
      maxWait: 2_000,
      trailing: true,
    },
  );
  useChannel({ key: "display_filters", projectId }, displayFilterscallback, true);

  return displayFilters.body;
};

export type DisplayFilter = ReturnType<typeof useDisplayFilters>[number];
